import React from 'react';
import { X, ChevronRight } from 'lucide-react';

const ALEX_GREEN = '#082900';

const MOCK_NOTIFICATIONS = [
  { id: '1', title: 'Welcome to Duty AI', timestamp: '3 months ago', read: false },
  { id: '2', title: 'Complete your profile to get matched with roles', timestamp: '3 months ago', read: true },
  { id: '3', title: 'New assessment available for you', timestamp: '2 months ago', read: true },
];

const NotificationPanel = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div className="fixed inset-0 z-[60] bg-black/15" onClick={onClose} />

      {/* Panel */}
      <div className="fixed left-0 sm:left-[60px] top-0 h-screen w-full sm:w-[340px] bg-white z-[70] shadow-xl flex flex-col" style={{ borderRight: '1px solid #eee' }}>
        {/* Header */}
        <div className="flex items-center justify-between px-5 pt-5 pb-4">
          <h2 className="text-xl font-bold text-gray-900" style={{ fontFamily: 'inherit' }}>Notifications</h2>
          <button
            onClick={onClose}
            className="p-1.5 text-gray-400 hover:text-gray-600 rounded-lg hover:bg-gray-100 transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Notification List */}
        <div className="flex-1 overflow-y-auto">
          {MOCK_NOTIFICATIONS.map((notification) => (
            <div
              key={notification.id}
              className="flex items-start gap-3 px-5 py-4 border-b border-gray-50 hover:bg-gray-50/80 cursor-pointer transition-colors group"
            >
              {/* Blue dot for unread */}
              <div className="mt-2 shrink-0">
                {!notification.read ? (
                  <div className="w-2 h-2 rounded-full" style={{ backgroundColor: ALEX_GREEN }} />
                ) : (
                  <div className="w-2 h-2" />
                )}
              </div>

              {/* Content */}
              <div className="flex-1 min-w-0">
                <p className="text-xs text-gray-400 mb-0.5" style={{ fontSize: '12px' }}>{notification.timestamp}</p>
                <p className={`text-sm leading-snug ${
                  notification.read ? 'text-gray-500' : 'text-gray-900 font-medium'
                }`}>
                  {notification.title}
                </p>
              </div>

              {/* Chevron */}
              <ChevronRight className="w-4 h-4 text-gray-300 group-hover:text-gray-400 mt-2 shrink-0 transition-colors" />
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default NotificationPanel;
